// V2 Assisting Blocks
// 
// This module registers all assisting blocks for V2.
// It first loads V1 blocks for backward compatibility, then registers V2-specific blocks.
//
// - V2 blocks use DIFFERENT names (e.g., 'rest_params_v2') 

import AssistingBlocksV1 from "../../v1/assistingBlocks";
// Import only ACTUAL assisting blocks that register Blockly.Blocks[]
import RestParamsV2 from "./RestParams";  // Registers 'rest_params_v2'

const AssistingBlocksV2 = function(props) {
    // Register all V1 assisting blocks first (for backward compatibility)
    // This ensures old saved scripts can still find 'rest_params', 'checkbox', etc.
    AssistingBlocksV1(props);
    
    // Register V2 assisting blocks with NEW names
    // V2 blocks use different names so both versions are available
    RestParamsV2(props);  // Registers 'rest_params_v2' (V2 RestService uses this name)
    
    return null;
};

export default AssistingBlocksV2;
